import React from 'react';
import {injectIntl} from 'react-intl';
import Profile from '@Components/Profile';

const ProfileList = ({intl, profiles, keyword}) => {
  const renderProfiles = () => {
    let result = [];
    if (profiles && profiles.length) {
      result = profiles.map((profile, index) => {
        return (
          <Profile key={index} profile={profile} keyword={keyword} itemOrder={index}/>
        );
      });
    }
    return result;
  };

  return (
    <>
      <div className="cards">
        <ul className="cards__list cards__list--format-list">
          {renderProfiles()}
        </ul>
      </div>
    </>
  );
};

export default injectIntl(ProfileList);
